export default "__VITE_ASSET__R39TE2GJ__"